var AIChat = React.createClass({
    getInitialState: function () {
        return {
            isInterrogativeFirstRequestGpt: false
        };
    },
    setIsInterrogativeFirstRequestGpt(value) {
        this.setState({ isInterrogativeFirstRequestGpt: value });
    },
    render: function () {
        return (
            <div hidden={!this.state.isInterrogativeFirstRequestGpt} className="ai-chat-app">
                <AIChatWindow setIsInterrogativeFirstRequestGpt={this.setIsInterrogativeFirstRequestGpt} />
            </div>
        );
    }
});